import Util from "../../libs/util/Util";
import PassengerBaseClass from "../common/PassengerBaseClass";
import gsap from "gsap";
import LtikeCommon from "../common/LtikeCommon";

/**
 * 航空券　検索枠　搭乗者　管理
 */
export default class PassengersClass extends PassengerBaseClass{
    constructor(_target,_parent){
        super($(_target+" .wrap",_parent));
        this.name = "PassengersClass";

        this.parent = _parent;

        this.modal = _target;

        this.maxNum = 6;
    }

    onCreate() {
        super.onCreate();

        this.error = $(this.modal+' [data-type="passengers_error"]',this.parent);

        this.error.css({display:"none"});
        gsap.set(this.error,{y:"5%"});
    }

    onError(){
        //console.log(this.name,"onError");
        gsap.killTweensOf(this.error);
        this.error.css({display:"block"});
        const time = 0.3;
        const ease = "power2.out";
        gsap.to(this.error,{duration:time,opacity:1,y:"0%",ease:ease,onComplete:()=>{
                gsap.to(this.error,{duration:time,delay:1,y:"5%",opacity:0,ease:ease,onComplete:()=>{
                        this.error.css({display:"",opacity:""});
                    }
                });
            }
        });
    }

    onCheckSubmitError(){
        const re = super.onCheckSubmitError();

        if(!re.isError) {
            re.data = this.getPassengers();
            //console.log("----",re.data);
            const res = PassengersClass.PassengersCheck(re.data);
            re.isError = res.isError;
            re.msg = res.msg;
        }
        return re;
    }

    /**
     * 搭乗者のエラーチェック
     * @param _data
     * @returns {{msg: string, isError: boolean}}
     * @constructor
     */
    static PassengersCheck(_data){
        let isError = false;
        let msg = "";

        let infant = 0;
        for(let k in _data.ageList){
            if(_data.ageList[k] < 2) infant += 1;
        }

        if(infant > _data.adult) {
            isError = true;
            msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR1;
        } else if(infant > 2){
            isError = true;
            msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR2;
        }
        return {isError:isError,msg:msg};
    }

}